import { usePermissionsModalContext } from '../../contexts/PermissionModalContext';
import { Box, type BoxProps } from '@mui/material';

type Props = BoxProps & {
  hasPermission: boolean;
};

export function CheckPermission({
  hasPermission,
  sx,
  children,
  ...rest
}: Props) {
  const { openPermissionsModal } = usePermissionsModalContext();

  return (
    <Box sx={{ position: 'relative', ...sx }} {...rest}>
      {children}
      {!hasPermission ? (
        <Box
          sx={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            cursor: 'not-allowed',
          }}
          onClick={openPermissionsModal}
        />
      ) : null}
    </Box>
  );
}
